/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FIVE_NUMBERS_W1_DECIMAL_REGEX } from '#utils/string/regex';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import Checkbox from '#components/general/Checkbox';
import AdelphiFormDivider from '#components/business/AdelphiFormDivider';
import Input from '#components/general/Input';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import { CHARGING_FIELDS, WASH_SCREEN_SET_UP_FIELDS, WASH_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const getChargingFields = ({ values, errors }) => {
  const getChargingValues = getSubStepValues(WASH_SUBSTEPS_IDS.CHARGING, values, errors);
  return [
    {
      key: 'titles',
      Component: AdelphiFieldsRow,
      fieldRowClassName: styles.timeOffAndChargingTitles,
      fields: [
        {
          key: 'dateAndTimeCharged',
          Component: () => (
            <div className={styles.columnTitle}>{t(`${WASH_SUBSTEPS_IDS.CHARGING}:dateAndTimeCharged`)}</div>
          )
        },
        {
          key: 'volumeCharged',
          Component: () => (
            <div className={styles.columnTitle}>{t(`${WASH_SUBSTEPS_IDS.CHARGING}:volumeCharged`)}</div>
          )
        }
      ]
    },
    {
      key: 'firstRow',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getChargingValues(WASH_SCREEN_SET_UP_FIELDS.WASH_RUN_DATE_AND_TIME, false),
          Component: Input,
          type: 'datetime-local',
          disabled: true
        },
        {
          ...getChargingValues(CHARGING_FIELDS.VOLUME_CHARGED, false),
          Component: Input,
          measure: MEASURE_TYPES.LITRES,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX
        }
      ]
    },
    {
      key: 'blankSpace',
      Component: AdelphiFormDivider
    },
    {
      ...getChargingValues(CHARGING_FIELDS.VALVES_CLOSED),
      Component: Checkbox,
      innerClassName: styles.innerCenterContainer
    }
  ];
};
